/*                   `. ___
                    __,' __`.                _..----....____
        __...--.'``;.   ,.   ;``--..__     .'    ,-._    _.-'
  _..-''-------'   `'   `'   `'     O ``-''._   (,;') _,'
,'________________                          \`-._`-','
 `._              ```````````------...___   '-.._'-:
    ```--.._      ,.                     ````--...__\-.
            `.--. `-`      Astro-Slide      ____    |  |`
              `. `.        By S.Masse      ,'`````.  ;  ;`
                `._`.        __________   `.      \'__/`
                   `-:._____/______/___/____`.     \  `
                               |       `._    `.    \
                                `._________`-.   `.   `.___
                                    `------'`

    Purpose: A general slider that enables easy left-right sliding of any object
             of any size, as long as your container can withstand it.

    CSS: Uses keyframe animations for sliding in and out.

    Markup:
      <div id='mySlider'>
        <div class='_slides'>
          *The stuff you want to slide*
        </div>
      </div>

    Usage:
      Required:
        var mySlider = new AstroSlider(document.querySelector('#mySlider'));

      Optional:
        mySlider.activeSlide = 3; // The slide you want to default to. Duh.
        mySlider.animationDuration = 500; // Sync with your CSS anim duration.

    Note: A minimum of 3 slides is required for the slider to work.

    TODO: Add automatic bullet and button creation

    TODO: Add touch events
*/

var AstroSlider = function(element) {
  this.DOMElement = element;
  this.slides = this.DOMElement.querySelectorAll('._slides > *');

  // Default values
  this.activeSlide = 0;
  this.animationDuration = 450;

  this.initializeDOM();
}

// Set intitial state for the slider.
AstroSlider.prototype.initializeDOM = function() {

  // Need a minimum of 3 slides for the slider to work.
  if (this.slides.length < 3) { return; }

  this.slides[this.activeSlide].classList.add('active');
}

// Go to previous or next slide
AstroSlider.prototype.moveSlides = function(dir) {
  // Prevents interaction with the slider while it is transitionning
  if (this.DOMElement.classList.contains('-transition'))
    return;

  this.outSlide = this.activeSlide;

  // Unset currently active slide.
  this.slides[this.activeSlide].classList.remove('active');

  if (dir == 'next') {
    // Get the new active slide's index
    (this.activeSlide < (this.slides.length - 1)) ? this.activeSlide++
                                                 : this.activeSlide = 0;
  }
  else if (dir == 'prev') {
    // Get the new active slide's index
    (this.activeSlide > 0) ? this.activeSlide--
                           : this.activeSlide = (this.slides.length - 1);
  }

  this.transitSlides(dir);
}

AstroSlider.prototype.goToSlide = function(index) {
  // Prevents interaction with the slider while it is transitionning
  if (this.DOMElement.classList.contains('-transition'))
    return;

  // Making sure nothing happens when you try to go to the currently active slide.
  if (this.activeSlide == index)
    return;

  this.outSlide = this.activeSlide;

  // Unset currently active slide.
  this.slides[this.activeSlide].classList.remove('active');

  // Determine the direction of the transition
  if (index > this.activeSlide) {
    var dir = 'next';
  }
  else if (index < this.activeSlide) {
    var dir = 'prev';
  }

  // Set the new active slide
  this.activeSlide = index;

  this.transitSlides(dir);
}

// Starts the sliding transition by adding, then removing the appropriate classes.
AstroSlider.prototype.transitSlides = function(dir) {
  this.slides[this.outSlide].classList.add('out_' + dir);
  this.slides[this.activeSlide].classList.add('in_' + dir);
  this.slides[this.activeSlide].classList.add('active');
  this.DOMElement.classList.add('-transition');

  this.updateBullets();

  // Remove the animation classes after they are completed.
  setTimeout(function () {
    this.slides[this.outSlide].classList.remove('out_' + dir);
    this.slides[this.activeSlide].classList.remove('in_' + dir);
    this.DOMElement.classList.remove('-transition');
  }.bind(this), this.animationDuration);
}

// If there are bullets, set the currently active one.
// Note: this.bullets is currently defined in the initialization script inside
//       the DOM. Look in example.html for more details
AstroSlider.prototype.updateBullets = function() {
  if (this.bullets) {
    for (i=0;i<this.slides.length;i++)
      this.bullets[i].classList.remove('active');

    this.bullets[this.activeSlide].classList.add('active');
  }
}
